import { z, ZodType } from 'zod';

export type Currency = {
	code: string;
};

export const currencySchema: ZodType<Currency> = z.object({
	code: z.string(),
});
